var styleDataHash = "baf7f351";
const injectCss = () => {
  var css = `.OB3p0,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.mGRmW,.vOtZg{height:386px;overflow:auto}[dir] .mGRmW,[dir] .vOtZg{margin-top:20px}[dir=ltr] .mGRmW,[dir=ltr] .vOtZg{margin-right:-16px;padding-right:16px}[dir=rtl] .mGRmW,[dir=rtl] .vOtZg{margin-left:-16px;padding-left:16px}.mGRmW.V35t9,.vOtZg.V35t9{height:calc(100vh - 190px)}.k-n4-{display:flex;flex-direction:column}[dir=ltr] .-Q7HE{float:right;text-align:right}[dir=rtl] .-Q7HE{float:left;text-align:left}[dir] ._90CK1{cursor:pointer}.b-CXg{align-items:center;display:flex;height:100%;justify-content:center;width:100%}[dir] .b-CXg{margin-top:50px}._9nlP3{height:100%;width:100%}._9nlP3,.vOtZg{align-items:center;display:flex;justify-content:center}.vOtZg{max-width:100%}.jZBOq{--wds-input-value-font-size-medium:14px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var giphy_selector_default = {
  "fontElementMap": "OB3p0",
  "giphy_selector_infinite_scroll_container": "mGRmW",
  "giphySelectorErrorContainer": "vOtZg",
  "mobile": "V35t9",
  "giphy_selector_infinite_scroll": "k-n4-",
  "giphy_selector_powerdByGiphy": "-Q7HE",
  "giphy_selector_gif_img_container": "_90CK1",
  "giphy_selector_spinner_load_more": "b-CXg",
  "giphy_selector_spinner_empty_modal": "_9nlP3",
  "searchInput": "jZBOq"
};
export {
  giphy_selector_default as default,
  injectCss
};
//# sourceMappingURL=giphy-selector-scss.js.map
